import { IoPlayOutline } from "react-icons/io5";
import { get_media_url } from "../../../api/utils";
import CardContainer from "./cardcontainer";

const VideoPost = ({ post, ...props }) => {
  return (
    <CardContainer className="relative overflow-hidden bg-black" {...props}>
      <IoPlayOutline className="absolute top-1 left-1 w-6 h-6" />
      <video
        className="w-full h-full object-cover"
        src={get_media_url(post.foreground_video)}
        autoPlay={false}
        preload="metadata"
      >
        Your browser does not support the video tag.
      </video>
    </CardContainer>
  );
};

export default VideoPost;
